var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckcrFr(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00001 2.66667C5.05449 2.66667 2.66668 5.05448 2.66668 8C2.66668 10.9455 5.05449 13.3333 8.00001 13.3333C10.9455 13.3333 13.3333 10.9455 13.3333 8C13.3333 5.05448 10.9455 2.66667 8.00001 2.66667ZM1.33334 8C1.33334 4.3181 4.31811 1.33334 8.00001 1.33334C11.6819 1.33334 14.6667 4.3181 14.6667 8C14.6667 11.6819 11.6819 14.6667 8.00001 14.6667C4.31811 14.6667 1.33334 11.6819 1.33334 8Z",
    fill: "#FF865C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4951 8.10457C11.4951 8.47276 11.1966 8.77124 10.8284 8.77124L7.72386 8.77124C7.35567 8.77124 7.05719 8.47276 7.05719 8.10457L7.05719 5.55229C7.05719 5.1841 7.35567 4.88562 7.72386 4.88562C8.09205 4.88562 8.39052 5.1841 8.39052 5.55229L8.39052 7.43791L10.8284 7.43791C11.1966 7.43791 11.4951 7.73638 11.4951 8.10457Z",
    fill: "#FF865C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckcrFr);
export default __webpack_public_path__ + "static/media/Check cr-fr.3091e4b3530372513145a4949e678dc8.svg";
export { ForwardRef as ReactComponent };